import { useEffect, useState } from 'react';
import classService from '../../../services/ClassService';
import { getFormattedClassRecords } from '../table/helpers';

export default function useFetchClassRefRecords() {
  const [classRefs, setClassRefs] = useState([]);
  const [classRefError, setClassRefError] = useState(null);
  const [classRefLoading, setClassRefLoading] = useState(false);

  useEffect(() => {
    const fetchClassRefRecords = async () => {
      try {
        setClassRefLoading(true);
        setClassRefError(null);

        // QBO is authoritative for the class list. MongoDB only stores the
        // app-specific classStatus and may not contain newly created classes.
        const classRefList = await classService.getClassListFromQBO();
        const qboClasses = classRefList.data?.data?.QueryResponse?.Class || [];
        const formattedClassRefs = getFormattedClassRecords(qboClasses);

        const classFromDB = await classService.getClassListFromDatabase().catch(() => null);
        const classRecords = classFromDB?.data?.data || [];

        const visibleClassRefs = formattedClassRefs.filter((classRef) => {
          const databaseClass = classRecords.find((classRecord) => classRecord.Id === classRef.value);
          return !databaseClass || databaseClass.classStatus;
        });

        setClassRefs(visibleClassRefs);
      } catch (e) {
        const errorMessage =
          e?.response?.data?.message ||
          (e?.code === 'ECONNABORTED'
            ? 'QuickBooks took too long to return activities. Please try again.'
            : e.message || 'Could not fetch activities from QuickBooks.');
        setClassRefError(errorMessage);
        setClassRefs([]);
      } finally {
        setClassRefLoading(false);
      }
    };

    fetchClassRefRecords();
  }, []);

  return { classRefs, classRefLoading, classRefError };
}
